import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Row } from 'antd';

import { DocumentResponse } from 'all-in-one-shared-api/dist/apis/documents/DocumentsResponse';

import PdfFileIcon from 'assets/images/documents/pdf-file-icon.svg';

import { IconCard } from 'components';
import FourItemColumn from 'components/fourItemColumn';
import { StyledTitle } from 'components/StyledTitle';

const ClaimDocumentRow = styled(Row)`
  margin-top: 16px;
`;

interface OthersDocuments {
  OthersDocuments: DocumentResponse[];
}

function OthersDocuments({ OthersDocuments }: OthersDocuments) {
  const { t } = useTranslation();
  return (
    <>
      <StyledTitle level={5} margin="40px 0 0 0">
        {t('documents.others')}
      </StyledTitle>
      <ClaimDocumentRow gutter={[{ xs: 8, sm: 16, md: 24 }, 16]} wrap>
        {OthersDocuments.map((document) => (
          <FourItemColumn key={document.name}>
            <IconCard
              title={document.name ?? ''}
              description={document.documentDate ?? ''}
              icon={PdfFileIcon}
              to={document.url ?? '#'}
              height="auto"
              isExternal={true}
            />
          </FourItemColumn>
        ))}
      </ClaimDocumentRow>
    </>
  );
}

export default OthersDocuments;
